import React, { useState } from "react";
import Logo from "../components/Logo";

const Sidebar = ({ sidebarItems, onSelectScreen, logout }) => {
  // Color mapping for active circle indicators
  const getActiveCircleColor = (href) => {
    const colorMap = {
      sleep:
        "tw-bg-purple-500 dark:tw-bg-purple-400 tw-text-white dark:tw-text-black",
      hydration:
        "tw-bg-blue-500 dark:tw-bg-blue-400 tw-text-white dark:tw-text-black",
      movement:
        "tw-bg-green-500 dark:tw-bg-green-400 tw-text-white dark:tw-text-black",
      mood: "tw-bg-yellow-500 dark:tw-bg-yellow-400 tw-text-white dark:tw-text-black",
      meditation:
        "tw-bg-indigo-500 dark:tw-bg-indigo-400 tw-text-white dark:tw-text-black",
      tracker:
        "tw-bg-orange-500 dark:tw-bg-orange-400 tw-text-white dark:tw-text-black",
      settings:
        "tw-bg-gray-500 dark:tw-bg-gray-400 tw-text-white dark:tw-text-black",
      support:
        "tw-bg-red-500 dark:tw-bg-red-400 tw-text-white dark:tw-text-black",
    };

    return (
      colorMap[href] ||
      "tw-bg-black dark:tw-bg-white tw-text-white dark:tw-text-black"
    );
  };
  const [showSidebar, setShowSidebar] = useState(false);

  const mainItems = sidebarItems.filter(
    (item) => !["support", "settings"].includes(item.href)
  );
  const footerItems = sidebarItems.filter((item) =>
    ["support", "settings"].includes(item.href)
  );

  const renderSidebarItem = (item, index) => (
    <li
      key={index}
      className={`${
        item.locked
          ? "tw-bg-gray-50 dark:tw-bg-gray-900 tw-opacity-50 hover:tw-opacity-80 tw-pointer-events-none"
          : "tw-bg-white dark:tw-bg-black hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800"
      }`}
    >
      <button
        onClick={() => {
          onSelectScreen(item.href.replace("#", ""));
          setShowSidebar(false);
        }}
        className={`tw-flex tw-items-center tw-justify-between tw-gap-2 tw-block tw-w-full text-left tw-transition-colors tw-duration-200 tw-ease-in-out ${
          item.locked
            ? "tw-text-gray-400 dark:tw-text-gray-100 tw-pr-8"
            : item.active
            ? "tw-text-black dark:tw-text-white dark:tw-bg-gray-800 tw-bg-gray-50"
            : "tw-text-gray-600 dark:tw-text-gray-200"
        }`}
      >
        <span className="tw-flex tw-gap-3 xl:tw-gap-4 tw-w-full">
          <span className="tw-w-full tw-py-4 tw-w-full tw-text-left tw-pl-4 xl:tw-pl-8">
            {item.label}
          </span>
          <span
            className={`${
              item.active
                ? getActiveCircleColor(item.href)
                : "tw-bg-transparent"
            } tw-w-1 tw-block tw-rounded-sm activeCircle`}
          ></span>
        </span>
        {item.locked && (
          <span className="tw-ml-2 tw-inline-flex tw-items-center tw-gap-2 tw-text-xs">
            <svg
              style={{ maxWidth: "20px" }}
              xmlns="http://www.w3.org/2000/svg"
              className="tw-h-5 tw-w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#9ca3af"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 8V7a5 5 0 00-10 0v1M5 8h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V10a2 2 0 012-2z"
              />
            </svg>
          </span>
        )}
      </button>
    </li>
  );

  return (
    <>
      <aside className="tw-z-40 tw-bg-white dark:tw-bg-black tw-shadow-md lg:tw-relative lg:tw-w-1/5 tw-max-h-screen lg:tw-h-screen tw-h-min-screen tw-text-black dark:tw-text-white tw-flex tw-flex-col">
        <div className="tw-flex tw-flex-col tw-justify-center tw-w-full lg:tw-h-full">
          <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
            <Logo className="tw-flex tw-items-start lg:tw-px-4 xl:tw-px-4 tw-py-4 lg:tw-py-8 tw-min-h-[70px] tw-h-full tw-max-h-[70px] lg:tw-max-h-auto lg:tw-max-h-[120px]" />
            <button
              onClick={() => setShowSidebar(!showSidebar)}
              className="lg:tw-hidden tw-z-50 tw-bg-black tw-text-xl tw-flex tw-text-white tw-px-2 tw-pb-1 tw-rounded-md"
            >
              ☰
            </button>
          </div>
          <nav
            className={`tw-w-full tw-pb-10 tw-flex tw-flex-col tw-flex-grow tw-justify-between tw-fixed tw-left-0 tw-top-[70px] tw-h-[calc(100vh-70px)] tw-z-40 tw-bg-white dark:tw-bg-black tw-transition-all tw-duration-300 lg:tw-w-full ${
              showSidebar ? "tw-translate-x-0" : "-tw-translate-x-full"
            } lg:tw-relative lg:tw-translate-x-0 lg:tw-top-0 lg:tw-h-full lg:tw-flex`}
          >
            <ul className="tw-list-none tw-p-0 tw-m-0">
              {mainItems.map(renderSidebarItem)}
            </ul>
            <div className="tw-mt-auto tw-w-full">
              <ul className="tw-list-none tw-p-0 tw-m-0">
                {footerItems.map(renderSidebarItem)}
                {logout && (
                  <li className="tw-py-4 tw-px-4 xl:tw-px-8 tw-bg-white dark:tw-bg-black hover:tw-bg-gray-50 dark:hover:tw-bg-gray-800">
                    <button
                      onClick={logout}
                      className="tw-text-left tw-w-full tw-text-gray-400 hover:tw-text-gray-900"
                    >
                      Log out
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
